import React  from 'react'
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export default function AmsAccordion (props: any) {

  const [expanded, setExpanded] = React.useState('');
  const handleChange = (panel:any) => (event:any, newExpanded:any) => {
        setExpanded(newExpanded ? panel : false);
    };

  return props.data.map((item:any, index:any) => {
    return (
      <ExpansionPanel square key={index} defaultExpanded={props.expandByDefault} onChange={handleChange(('panel' + index))}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <TypographySummary>{item.summary}</TypographySummary>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <TypographyDetail>
            {item.detail}
          </TypographyDetail>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  })
}

const ExpansionPanel = withStyles({
  root: {
    border: 'none',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',

    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    border: 'none',
    backgroundColor: '#FBFBFB',
    marginTop: '-8px',
    marginBottom: '-8px',
    minHeight: 10,
    '&$expanded': {
      minHeight: 30,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);

const TypographySummary = withStyles({
  root: {
    fontSize: "1.8rem",
    color: "#333333",
  }
})(Typography);

const TypographyDetail = withStyles({
  root: {
    fontSize: "1.4rem",
    // paddingTop: '0px',
    fontWeight: 400,
    color: "#333333",
  }
})(Typography);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    backgroundColor: '#FBFBFB',
    paddingTop: '2px',
    paddingBottom: '6px',
  },
}))(MuiExpansionPanelDetails);
